import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type AppLanguage = 'ar' | 'en';

const STORAGE_KEY = 'zt.lang';

const DICTS: Record<AppLanguage, Record<string, string>> = {
  ar: {
    'header.free_shipping': 'شحن مجاني داخل مصر للطلبات المؤهلة',
    'header.deals': 'أفضل عروض الإلكترونيات - تتحدث يوميا',
    'header.search_placeholder': 'ابحث عن منتجات أو SKU أو علامات تجارية...',
    'header.search_suggestions': 'اقتراحات البحث',
    'header.search_loading': 'جاري البحث…',
    'header.search_no_results': 'لا توجد نتائج',
    'header.search_view_all': 'عرض كل النتائج لـ',
    'header.sign_in': 'تسجيل الدخول',
    'header.logout': 'تسجيل الخروج',
    'header.cart': 'السلة',
    'header.home': 'الرئيسية',
    'header.all_categories': 'كل الأقسام',
    'header.shop_by_category': 'تسوق حسب القسم',
    'header.categories': 'الأقسام',
    'header.language': 'اللغة',
    'header.shop_all': 'تسوق كل',
    'header.view_all': 'عرض الكل',
    'offers.use_code': 'استخدم الكود',
    'offers.shop_now': 'تسوق الآن',
    'checkout.title': 'إتمام الطلب',
    'checkout.subtitle': 'أدخل بيانات الشحن واختر طريقة الدفع لإكمال طلبك',
    'checkout.shipping_and_payment': 'الشحن والدفع',
    'checkout.full_name': 'الاسم الكامل',
    'checkout.phone': 'رقم الهاتف',
    'checkout.phone_required': 'رقم الهاتف مطلوب.',
    'checkout.phone_invalid': 'أدخل رقم موبايل مصري صحيح (مثل 01012345678).',
    'checkout.form_invalid': 'يرجى تصحيح الحقول المطلوبة قبل إتمام الطلب.',
    'checkout.full_name_required': 'الاسم الكامل مطلوب.',
    'checkout.full_name_invalid': 'الاسم يجب أن يكون 3 أحرف على الأقل.',
    'checkout.address_required': 'عنوان التوصيل مطلوب.',
    'checkout.address_invalid': 'العنوان يجب أن يكون 6 أحرف على الأقل.',
    'checkout.country_required': 'اختر الدولة.',
    'checkout.governorate_required': 'اختر المحافظة.',
    'checkout.city_required': 'اختر المدينة.',
    'checkout.payment_required': 'اختر طريقة الدفع.',
    'checkout.branch_required': 'اختر فرع الاستلام.',
    'checkout.optional': 'اختياري',
    'checkout.email_invalid': 'أدخل بريدًا إلكترونيًا صحيحًا.',
    'checkout.address': 'عنوان التوصيل',
    'checkout.country': 'الدولة',
    'checkout.select_country': 'اختر الدولة',
    'checkout.branch': 'الفرع',
    'checkout.payment_method': 'طريقة الدفع',
    'checkout.payment_intro': 'اختر وسيلة واحدة. سيظهر طلبك في لوحة الإدارة في كل الحالات.',
    'checkout.payment_credit': 'بطاقة ائتمان / خصم',
    'checkout.payment_branch': 'استلام من الفرع',
    'checkout.payment_cod': 'الدفع عند الاستلام',
    'checkout.hint_credit': 'ادفع بأمان عبر Paymob (سيتم تحويلك لإكمال الدفع).',
    'checkout.hint_cod': 'ادفع نقدا عند استلام الطلب. لا تحتاج بطاقة.',
    'checkout.hint_branch': 'اطلب أونلاين واستلم من الفرع المختار بدون شحن.',
    'checkout.branch_pickup': 'فرع الاستلام',
    'checkout.notes': 'ملاحظات الطلب (اختياري)',
    'checkout.notes_placeholder': 'تعليمات التوصيل، اسم المبنى، الدور، ...',
    'checkout.discount_code': 'كود الخصم',
    'checkout.discount_placeholder': 'رمز ترويجي (اختياري)',
    'checkout.discount_apply': 'تطبيق',
    'checkout.discount_applied': 'الخصم',
    'checkout.shipping_discount': 'خصم الشحن',
    'checkout.complete_your_order': 'أكمل طلبك',
    'checkout.related_products_subtitle': 'منتجات مرتبطة حسب العناصر الموجودة في سلتك',
    'checkout.discount_enter_code': 'أدخل الكود ثم اضغط تطبيق للتحقق.',
    'checkout.discount_not_applicable': 'لا يمكن تطبيق هذا الكود على سلتك.',
    'checkout.discount_preview_error': 'تعذر التحقق من الكود. حاول مرة أخرى.',
    'checkout.cod_disabled_threshold': 'الدفع عند الاستلام غير متاح لأن إجمالي السلة تجاوز الحد المسموح.',
    'checkout.cod_unavailable': 'غير متاح',
    'product.wishlist_add': 'إضافة إلى المفضلة',
    'product.wishlist_remove': 'إزالة من المفضلة',
    'product.wishlist_login':
      'يجب تسجيل الدخول لإتمام الشراء أو لإضافة منتجات إلى السلة أو إلى المفضلة.',
    'product.compare_add': 'إضافة للمقارنة',
    'product.compare_added': 'تمت الإضافة إلى المقارنة',
    'product.compare_full': 'المقارنة ممتلئة (٤ منتجات كحد أقصى).',
    'wishlist.error': 'تعذّر تحديث المفضلة.',
    'wishlist.added': 'تمت الإضافة إلى المفضلة.',
    'wishlist.removed': 'تمت الإزالة من المفضلة.',
    'checkout.loading_methods': 'جاري تحميل طرق الدفع...',
    'checkout.continue_payment': 'متابعة إلى الدفع الآمن',
    'checkout.place_cod': 'تأكيد الطلب (الدفع عند الاستلام)',
    'checkout.place_branch': 'تأكيد الطلب (استلام من الفرع)',
    'checkout.shipping_data': 'بيانات الشحن',
    'checkout.summary': 'ملخص الطلب',
    'checkout.confirmed': 'تم تأكيد الطلب',
    'checkout.back_home': 'العودة للتسوق',
    'checkout.governorate': 'المحافظة',
    'checkout.select_governorate': 'اختر المحافظة',
    'checkout.city': 'المدينة',
    'checkout.select_city': 'اختر المدينة',
    'checkout.subtotal': 'المجموع الفرعي',
    'checkout.shipping': 'الشحن (تقديري)',
    'checkout.free_shipping_remaining_before': 'اشتري ب',
    'checkout.free_shipping_remaining_after': 'للحصول على توصيل مجاني',
    'checkout.shipping_base': 'سعر الشحن الأساسي',
    'checkout.shipping_extra': 'الوزن الإضافي',
    'checkout.shipping_included_kg': 'الوزن المشمول',
    'checkout.shipping_dynamic_note': 'الشحن ديناميكي: إذا تجاوز وزن المنتجات الوزن المشمول المحدد من الإدارة، يتم تطبيق الرسوم الإضافية لكل كيلوجرام تلقائيا.',
    'checkout.total': 'الإجمالي',
    'checkout.order_number': 'رقم الطلب',
    'checkout.email': 'البريد الإلكتروني',
    'checkout.leave_title': 'هل تريد مغادرة الدفع؟',
    'checkout.leave_subtitle': 'أخبرنا لماذا تغادر — يساعدنا ذلك على تحسين التجربة.',
    'checkout.leave_reason_price': 'السعر مرتفع',
    'checkout.leave_reason_shipping': 'الشحن / التوصيل',
    'checkout.leave_reason_payment': 'قلق من الدفع',
    'checkout.leave_reason_browsing': 'أتصفح فقط',
    'checkout.leave_reason_other': 'سبب آخر',
    'checkout.leave_note_label': 'ملاحظة (اختياري)',
    'checkout.leave_note_placeholder': 'أضف تفاصيل إن أردت…',
    'checkout.leave_stay': 'البقاء وإكمال الطلب',
    'checkout.leave_confirm': 'مغادرة',
    'checkout.thank_you': 'شكرا لك! طلبك',
    'checkout.created_success': 'تم إنشاؤه بنجاح.',
    'checkout.redirecting_paymob': 'جاري التحويل إلى Paymob...',
    'checkout.placing_order': 'جاري إنشاء الطلب...',
    'checkout.error_load_branches': 'تعذر تحميل الفروع.',
    'checkout.error_place_order': 'تعذر إتمام الطلب الآن. يرجى المحاولة مرة أخرى.',
    'checkout.paymob_return_success': 'تم الدفع بنجاح. تم تأكيد طلبك.',
    'checkout.paymob_return_failed': 'لم يكتمل الدفع. يمكنك المحاولة مرة أخرى أو اختيار طريقة دفع أخرى.',
    'checkout.paymob_return_failed_title': 'فشل الدفع',
    'checkout.paymob_return_unknown': 'انتهت عملية الدفع. إذا تم خصم مبلغ من بطاقتك ولم يظهر الطلب مؤكداً، تواصل مع الدعم.',
    'checkout.paymob_return_failed_stale_state':
      'تم رفض الدفع، لكن الطلب ما زال «معلّقاً» في النظام—غالباً لم يصل تأكيد Paymob للخادم (تحقق من Paymob:CallbackUrl وPaymob:HmacSecret). لن يُعتبر الطلب مؤكداً للشحن.',
    'checkout.loading_locations': 'جاري تحميل المناطق...',
    'common.scroll_previous': 'السابق',
    'common.scroll_next': 'التالي',
    'carousel.scroll_categories': 'تمرير أقسام التسوق',
    'carousel.scroll_products': 'تمرير المنتجات',
    'common.view': 'عرض',
    'common.search': 'بحث',
    'common.filters': 'الفلاتر',
    'common.loading_page': 'جاري تحميل الصفحة…',
    'common.loading_sections': 'جاري تحميل الأقسام…',
    'common.categories': 'الأقسام',
    'common.featured_products': 'منتجات مميزة',
    'common.price': 'السعر',
    'common.sort': 'الترتيب',
    'common.recommended': 'مقترح',
    'common.price_low_high': 'السعر: من الأقل للأعلى',
    'common.price_high_low': 'السعر: من الأعلى للأقل',
    'common.add_to_cart': 'أضف إلى السلة',
    'common.added': 'تمت الإضافة',
    'common.cancel': 'إلغاء',
    'common.close': 'إغلاق',
    'contact.call_chooser_title': 'اختر رقم الاتصال',
    'contact.call_mobile': 'موبايل',
    'contact.call_hotline': 'الخط الساخن',
    'contact.dock_label': 'تواصل معنا',
    'common.search_results': 'نتائج البحث',
    'common.no_products': 'لا توجد منتجات متاحة',
    'common.request_failed': 'فشل الطلب. يرجى المحاولة مرة أخرى.',
    'common.sign_in_required_title': 'تسجيل الدخول مطلوب',
    'common.sign_in_required_detail':
      'يجب تسجيل الدخول لإتمام الشراء أو لإضافة منتجات إلى السلة أو إلى المفضلة.',
    'cart.added': 'تمت إضافة المنتج إلى السلة',
    'cart.login_required':
      'يجب تسجيل الدخول لإتمام الشراء أو لإضافة منتجات إلى السلة أو إلى المفضلة.',
    'cart.add_error': 'تعذر إضافة المنتج إلى السلة',
    'header.english': 'الإنجليزية',
    'header.arabic': 'العربية',
    'header.home_aria': 'الرئيسية - زيرو تك',
    'header.account': 'الحساب',
    'header.wishlist': 'المفضلة',
    'header.my_orders': 'طلباتي',
    'header.compare': 'مقارنة',
    'header.categories_label': 'التصنيفات',
    'header.quick_links': 'روابط سريعة',
    'header.track_order': 'تتبع طلبي',
    'header.contact_us': 'تواصل معنا',
    'wishlist.title': 'قائمة الرغبات',
    'wishlist.subtitle': 'المنتجات التي حفظتها للمراجعة لاحقا.',
    'wishlist.empty_title': 'قائمة الرغبات فارغة',
    'wishlist.empty_subtitle': 'أضف منتجات من صفحات المنتجات لتظهر هنا.',
    'wishlist.empty_cta': 'متابعة التسوق',
    'wishlist.move_all': 'نقل الكل إلى السلة',
    'wishlist.move_all_done': 'تمت إضافة العناصر إلى السلة',
    'wishlist.remove': 'إزالة',
    'wishlist.move_to_cart': 'أضف إلى السلة',
    'wishlist.loading': 'جاري تحميل المفضلة...',
    'wishlist.load_error': 'تعذّر تحميل المفضلة. حاول مرة أخرى.',
    'compare.title': 'مقارنة المنتجات',
    'compare.subtitle': 'قارن حتى أربعة منتجات جنبا إلى جنب.',
    'compare.empty': 'لا توجد منتجات للمقارنة',
    'compare.add_products': 'أضف منتجات من صفحة التفاصيل أو من القوائم.',
    'compare.browse': 'تصفح المنتجات',
    'compare.clear': 'مسح الكل',
    'compare.full_hint': 'يمكنك مقارنة حتى ٤ منتجات.',
    'compare.column_product': 'المنتج',
    'compare.column_price': 'السعر',
    'compare.column_brand': 'العلامة',
    'compare.column_stock': 'التوفر',
    'compare.column_category': 'القسم',
    'compare.remove': 'إزالة من المقارنة',
    'compare.loading': 'جاري التحميل...',
    'compare.in_stock': 'متوفر',
    'compare.out_of_stock': 'غير متوفر',
    'support.title': 'الدعم',
    'support.subtitle': 'تواصل معنا لأي استفسار أو مساعدة.',
    'support.form_heading': 'تواصل معنا',
    'support.form_intro': 'أرسل رسالة وسنعاود الاتصال بك في أقرب وقت.',
    'support.form_name': 'الاسم',
    'support.form_name_ph': 'اسمك (اختياري)',
    'support.form_email': 'البريد الإلكتروني',
    'support.form_email_ph': 'you@example.com',
    'support.form_message': 'الرسالة',
    'support.form_message_ph': 'كيف يمكننا مساعدتك؟',
    'support.submit': 'إرسال',
    'support.form_success': 'تم استلام رسالتك. شكرا لتواصلك معنا.',
    'support.contact_title': 'بيانات الاتصال',
    'support.contact_phone': 'الهاتف',
    'support.contact_email': 'البريد',
    'support.contact_hours': 'الأحد–الخميس ١٠ ص–٦ م',
    'support.map_placeholder': 'خريطة — أضف تضمين الخريطة لاحقا',
    'support.map_aria': 'موقع تقريبي على الخريطة',
    'return_policy.title': 'سياسة الإسترجاع والإستبدال',
    'return_policy.subtitle': 'سياسة الاستبدال والإرجاع المحدثة لمنتجات شركتنا.',
    'return_policy.main_heading': 'سياسة الاستبدال والإرجاع المحدثة لمنتجات شركتنا',
    'return_policy.section1_title': 'أولًا: استرجاع أو استبدال المنتج لوجود عيب صناعة',
    'return_policy.section1_body':
      'يحق لعميلنا استبدال المنتج أو استرجاعه خلال ثلاثين يومًا من تاريخ الشراء فقط عند وجود عيب صناعة مؤكد بتقرير فني صادر عن مراكز الصيانة أو الخدمة المعتمدة لدينا. هذا الشرط يشمل منتجات العناية الشخصية التزامًا بالشروط الصحية والقانونية. بعد انقضاء هذه المدة لن يمكن استبدال المنتج أو استرجاعه لأي سبب كان ويلزم العميل التواصل مع خدمة العملاء على الرقم +20 104 477 7379 لتسجيل بلاغ صيانة وفقًا للمادة 21 من قانون حماية المستهلك.',
    'return_policy.section2_title': 'ثانيًا: شروط عامة للاسترجاع أو الاستبدال',
    'return_policy.section2_body':
      'عند استرجاع المنتج أو استبداله يجب أن تكون العبوة الأصلية وجميع مواد التغليف بحالتها السليمة وأن يكون المنتج بجميع مشتملاته الأصلية ولم يجرِ فتحه أو استخدامه ويجب أن يكون مصحوبًا بكافة المستندات الأصلية بما في ذلك الفاتورة. في حال وجود هدية مرافقة لطلب الشراء يجب استرجاعها مع المنتج وإلا لن تقبل عملية الاستبدال أو الاسترجاع. إذا جرى استرجاع أو استبدال منتج تم شراؤه بسعر مخفض أو ضمن عرض فسيجرى رد المبلغ الذي دفعه العميل فقط.',
    'return_policy.section3_title': 'ثالثًا: استرجاع أو استبدال المنتج دون عيب صناعة',
    'return_policy.section3_intro':
      'في حال رغبة العميل في استبدال أو استرجاع المنتج دون وجود عيب صناعة وذلك خلال أربعة عشر يومًا من تاريخ استلام المنتج باستثناء منتجات العناية الشخصية التي تخضع لشروط صحية خاصة وفقًا للمادة 17 من قانون حماية المستهلك يطبق ما يلي:',
    'return_policy.section3_item1_title': 'إذا لم يجرِ فتح عبوة المنتج أو استخدامه والمنتج ما زال بحالته الأصلية',
    'return_policy.section3_item1_body':
      'يحق للمستهلك طلب استبدال أو استرداد قيمة المنتج خلال المدة المذكورة شريطة أن يكون المنتج بذات الحالة التي كانت عليها السلعة وقت التعاقد أي لم يجرِ فتحه أو استخدامه. في هذه الحالة يجرى استبدال المنتج مع تسوية فرق السعر بين الموديلات إن وجد أو استرجاع المنتج ورد قيمته بعد خصم مصاريف الشحن البالغة 300 جنيه مصري لأجهزة التكييفات فقط وفقًا للمادة 40 فقرة 1 و 2 من قانون حماية المستهلك. بالإضافة إلى ذلك في حال الدفع الإلكتروني عبر VISA / Master أو فودافون كاش أو اتصالات كاش يجرى خصم مصاريف إدارية بواقع 1.5% من قيمة الجهاز وفي حال الدفع عبر خدمات فوري يجرى خصم 2.25% وفي حال الدفع عبر ماكينات MPOS يجرى خصم 1.45% + 1 جنيه.',
    'return_policy.section3_item2_title': 'إذا جرى فتح عبوة المنتج',
    'return_policy.section3_item2_body':
      'على الرغم من أن المادة 17 فقرة 2 من قانون حماية المستهلك قد لا تمنح المستهلك الحق في الاستبدال أو الاسترجاع إذا جرى فتح عبوة المنتج أو استخدامه واستثناءً من ذلك وحرصًا منا على مرونة التعامل يجرى استبدال المنتج مع تسوية فرق السعر بين الموديلات إن وجد أو استرجاع الجهاز ورد قيمته بعد خصم نسبة 5% من إجمالي قيمة الجهاز مقابل إعادة التعبئة والتغليف بالإضافة إلى خصم مصاريف الشحن (300 جنيه لأجهزة التكييفات) وجميع المصاريف الإدارية المذكورة سابقًا للدفع الإلكتروني.',
    'return_policy.contact_lead': 'للاستفسار أو تسجيل بلاغ صيانة، تواصل مع خدمة العملاء على الرقم الموحد',
    'branches.title': 'فروعنا',
    'branches.tagline': 'أقرب مما تتخيل ✨',
    'branches.subtitle': 'أياً كان مكانك، أكيد هتلاقي فرع قريب منك 📍',
    'branches.map': '📍 الخريطة',
    'branches.call': '📞 اتصال',
    'branches.whatsapp': '💬 واتساب',
    'branches.hotline_lead': 'زورونا في أقرب فرع أو كلمونا على',
    'branches.loading': 'جاري تحميل الفروع...',
    'branches.empty': 'لا توجد فروع متاحة حالياً.',
    'branches.load_error': 'تعذر تحميل الفروع. حاول مرة أخرى لاحقاً.',
    'account.auth_hero_title': 'مرحبا بك في زيرو تك',
    'account.auth_hero_subtitle': 'سجّل الدخول أو أنشئ حسابا لإدارة طلباتك وسلتك.',
    'account.hero_login': 'تسجيل الدخول',
    'account.hero_register': 'إنشاء حساب',
    'account.register_account_title': 'إنشاء حساب',
    'account.confirm_password_placeholder': 'أكد كلمة المرور',
    'account.accept_terms_prefix': 'أوافق على',
    'account.terms_link': 'الشروط',
    'account.accept_terms_and': 'و',
    'account.privacy_link': 'سياسة الخصوصية',
    'account.no_account': 'ليس لديك حساب؟',
    'account.have_account': 'لديك حساب بالفعل؟',
    'search.subtitle': 'ابحث عن المنتجات والباقات والعروض.',
    'search.enter_query': 'أدخل كلمة بحث لعرض المنتجات.',
    'header.view_category': 'عرض التصنيف',
    'header.expand_category': 'توسيع',
    'header.collapse_category': 'طي',
    'catalog.filter_products': 'تصفية المنتجات',
    'catalog.product_listing': 'قائمة المنتجات',
    'catalog.sort_products': 'ترتيب المنتجات',
    'catalog.min': 'الأدنى',
    'catalog.max': 'الأعلى',
    'catalog.apply_price': 'تطبيق السعر',
    'catalog.brand': 'العلامة التجارية',
    'catalog.no_brand_data': 'لا توجد بيانات علامة تجارية ضمن هذا القسم.',
    'catalog.availability': 'التوفر',
    'catalog.in_stock_only': 'المتاح فقط',
    'catalog.clear_filters': 'مسح كل الفلاتر',
    'catalog.loading_products': 'جار تحميل المنتجات...',
    'catalog.features': 'المميزات',
    'catalog.sale': 'خصم',
    'catalog.new': 'جديد',
    'catalog.all_products': 'كل المنتجات',
    'catalog.unknown_category': 'هذا التصنيف',
    'catalog.product_count_badge': 'عدد المنتجات',
    'catalog.no_products_filtered': 'لا توجد منتجات مطابقة للفلاتر.',
    'catalog.load_error': 'تعذر تحميل المنتجات.',
    'account.secure_account': 'حساب آمن',
    'account.sign_in_title': 'سجّل دخولك إلى حسابك',
    'account.create_title': 'أنشئ حسابك',
    'account.sign_in_subtitle': 'الوصول إلى السلة وإتمام الطلب وطلباتك.',
    'account.create_subtitle': 'سجّل حسابا لحفظ السلة وإكمال الطلب.',
    'account.login': 'دخول',
    'account.register': 'تسجيل',
    'account.full_name': 'الاسم الكامل',
    'account.full_name_placeholder': 'الاسم الكامل',
    'account.email': 'البريد الإلكتروني',
    'account.email_placeholder': 'you@example.com',
    'account.phone_number': 'رقم الهاتف',
    'account.phone_placeholder': '01012345678',
    'account.phone_required': 'رقم الهاتف مطلوب.',
    'account.phone_invalid': 'أدخل رقم موبايل مصري صحيح من 11 رقم (مثل 01012345678).',
    'account.email_required': 'البريد الإلكتروني مطلوب.',
    'account.email_invalid': 'صيغة البريد الإلكتروني غير صحيحة.',
    'account.full_name_required': 'الاسم الكامل مطلوب.',
    'account.full_name_invalid': 'الاسم يجب أن يكون 3 أحرف على الأقل.',
    'account.password': 'كلمة المرور',
    'account.password_placeholder': '6 أحرف على الأقل',
    'account.password_required': 'كلمة المرور مطلوبة.',
    'account.password_min': 'كلمة المرور يجب أن تكون 6 أحرف على الأقل.',
    'account.terms_required': 'يجب الموافقة على الشروط وسياسة الخصوصية.',
    'account.forgot_password': 'نسيت كلمة المرور؟',
    'account.forgot_title': 'استعادة كلمة المرور',
    'account.forgot_subtitle': 'أدخل بريدك المسجل وسنرسل رابط إعادة التعيين.',
    'account.forgot_submit': 'إرسال رابط الاستعادة',
    'account.forgot_success': 'إذا وُجد حساب بهذا البريد، تم إرسال رابط إعادة تعيين كلمة المرور.',
    'account.forgot_send_failed': 'تعذر إرسال بريد إعادة التعيين. حاول مرة أخرى لاحقاً.',
    'account.reset_password': 'إعادة تعيين كلمة المرور',
    'account.reset_title': 'تعيين كلمة مرور جديدة',
    'account.reset_subtitle': 'أدخل كلمة المرور الجديدة مرتين.',
    'account.reset_submit': 'حفظ كلمة المرور',
    'account.reset_success': 'تم تحديث كلمة المرور. يمكنك تسجيل الدخول الآن.',
    'account.reset_failed': 'تعذر إعادة تعيين كلمة المرور. الرابط غير صالح أو منتهٍ.',
    'account.reset_token_missing': 'رابط إعادة التعيين غير مكتمل.',
    'account.back_to_login': 'العودة لتسجيل الدخول',
    'account.show_password': 'إظهار كلمة المرور',
    'account.hide_password': 'إخفاء كلمة المرور',
    'account.please_wait': 'يرجى الانتظار...',
    'account.sign_in': 'تسجيل الدخول',
    'account.create_account': 'إنشاء حساب',
    'account.overview': 'نظرة عامة',
    'account.orders': 'الطلبات',
    'account.addresses': 'العناوين',
    'account.security': 'الأمان',
    'account.change_password': 'تغيير كلمة المرور',
    'account.change_password_hint': 'أدخل كلمة المرور الحالية وكلمة المرور الجديدة.',
    'account.current_password': 'كلمة المرور الحالية',
    'account.new_password': 'كلمة المرور الجديدة',
    'account.confirm_password': 'تأكيد كلمة المرور',
    'account.update_password': 'تحديث كلمة المرور',
    'account.password_mismatch': 'كلمة المرور الجديدة وتأكيدها غير متطابقين.',
    'account.password_same_as_current': 'كلمة المرور الجديدة يجب أن تختلف عن الحالية.',
    'account.current_password_incorrect': 'كلمة المرور الحالية غير صحيحة.',
    'account.password_changed': 'تم تحديث كلمة المرور بنجاح.',
    'account.password_change_failed': 'تعذر تحديث كلمة المرور. تحقق من كلمة المرور الحالية.',
    'account.sign_out': 'تسجيل الخروج',
    'account.core_information': 'المعلومات الأساسية',
    'account.email_address': 'عنوان البريد',
    'account.save_profile': 'حفظ البيانات',
    'account.profile_updated': 'تم تحديث بياناتك بنجاح.',
    'account.profile_update_failed': 'تعذر تحديث البيانات. حاول مرة أخرى.',
    'account.profile_load_failed': 'تعذر تحميل بيانات الحساب.',
    'account.email_already_exists': 'البريد الإلكتروني مستخدم بالفعل.',
    'account.loading_orders': 'جار تحميل طلباتك...',
    'account.no_orders': 'لا توجد طلبات بعد.',
    'account.request_failed': 'تعذر إتمام الطلب. يرجى المحاولة مرة أخرى.',
    'account.session_expired_title': 'انتهت الجلسة',
    'account.session_expired_message': 'انتهت مدة الجلسة. سجّل الدخول مرة أخرى لمتابعة التسوق.',
    'toast.notice': 'تنبيه',
    'toast.cart_updated': 'تم تحديث السلة',
    'account.total': 'الإجمالي',
    'account.shipping': 'الشحن',
    'account.status': 'الحالة',
    'account.status_delivered': 'تم التسليم',
    'account.status_cancelled': 'ملغى',
    'account.status_returned': 'مرتجع',
    'account.status_in_progress': 'قيد التنفيذ',
    'account.col_order_ref': 'مرجع الطلب',
    'account.col_product': 'المنتج',
    'account.col_date': 'تاريخ الشراء',
    'account.col_status': 'مؤشر الحالة',
    'account.col_total': 'القيمة الإجمالية',
    'account.col_details': 'التفاصيل',
    'account.view_details': 'عرض',
    'account.view_order': 'عرض الطلب',
    'account.back_to_orders': 'العودة للطلبات',
    'account.loading_order_detail': 'جار تحميل تفاصيل الطلب...',
    'account.order_detail_failed': 'تعذر تحميل تفاصيل الطلب.',
    'account.payment_method': 'طريقة الدفع',
    'account.payment_status': 'حالة الدفع',
    'account.shipping_details': 'عنوان الشحن',
    'account.order_items': 'المنتجات',
    'account.qty': 'الكمية',
    'account.subtotal': 'المجموع الفرعي',
    'account.discount': 'الخصم',
    'account.notes': 'ملاحظات',
    'account.status_pending': 'قيد الانتظار',
    'account.status_confirmed': 'مؤكد',
    'account.status_processing': 'قيد المعالجة',
    'account.status_shipped': 'تم الشحن',
    'account.status_declined': 'مرفوض',
    'account.payment_pending': 'قيد الانتظار',
    'account.payment_processing': 'قيد المعالجة',
    'account.payment_completed': 'مكتمل',
    'account.payment_failed': 'فشل',
    'account.payment_refunded': 'مسترد',
    'account.payment_cancelled': 'ملغى',
    'account.payment_declined': 'مرفوض',
    'account.advanced_filters': 'تصفية متقدمة',
    'account.filters_hint': 'سيتم ربط التصفية المتقدمة بالخادم لاحقا.',
    'account.section_soon': 'هذا القسم قيد التطوير.',
    'cart.breadcrumb': 'الرئيسية / سلة التسوق',
    'cart.breadcrumb_home': 'الرئيسية',
    'cart.breadcrumb_current': 'سلة التسوق',
    'cart.hero_title': 'سلة التسوق',
    'cart.title': 'سلة التسوق',
    'cart.recommended_title': 'منتجات مقترحة لك',
    'cart.recommended_subtitle': 'منتجات من نفس أقسام سلتك',
    'cart.empty_button': 'إفراغ سلة التسوق',
    'cart.remove': 'حذف',
    'cart.remove_item': 'إزالة المنتج من السلة',
    'checkout.cart_empty': 'سلتك فارغة. أضف منتجات للمتابعة.',
    'cart.coupon_placeholder': 'أدخل كود الخصم',
    'cart.apply_coupon': 'تطبيق',
    'cart.available_offers': 'عروض متاحة',
    'cart.tap_to_apply': 'اضغط لتطبيق العرض فوراً، أو اكتب كوداً آخر يدوياً.',
    'cart.offer_applied': 'مُطبَّق',
    'cart.order_summary': 'ملخص الطلب',
    'cart.subtotal': 'المجموع الفرعي',
    'cart.total': 'الإجمالي',
    'cart.proceed_checkout': 'الانتقال إلى الدفع',
    'cart.empty_title': 'سلتك فارغة',
    'cart.empty_subtitle': 'أضف منتجات إلى سلتك للمتابعة.',
    'cart.continue_shopping': 'متابعة التسوق',
    'cart.sign_in_required': 'يتطلب تسجيل الدخول',
    'cart.sign_in_prompt': 'سجّل الدخول لعرض وإدارة سلتك.',
    'cart.go_to_account': 'الذهاب إلى الحساب',
    'cart.coupon_discount': 'خصم الكوبون',
    'cart.use_code': 'استخدم الكود',
    'cart.shipping_note': '(لا تشمل رسوم الشحن)',
    'cart.coupon_enter_code': 'يرجى إدخال كود الخصم.',
    'cart.coupon_not_available': 'تطبيق القسائم غير متاح حاليا.',
    'cart.item_removed': 'تمت إزالة المنتج من السلة.',
    'cart.item_remove_failed': 'تعذر إزالة المنتج.',
    'cart.cleared': 'تم إفراغ السلة.',
    'cart.clear_failed': 'تعذر إفراغ السلة.',
    'cart.quantity_label': 'الكمية',
    'footer.newsletter_title': 'اشترك في نشرتنا الإخبارية',
    'footer.email_placeholder': 'أدخل بريدك الإلكتروني',
    'footer.submit': 'إرسال',
    'footer.tagline': 'نقدم حلول أمان شاملة وحققنا نجاحات رائعة في مختلف القطاعات الصناعية.',
    'footer.language': 'اللغة',
    'footer.lang_ar': 'العربية',
    'footer.lang_en': 'الإنجليزية',
    'footer.social_links': 'روابط التواصل',
    'footer.facebook': 'فيسبوك',
    'footer.whatsapp': 'واتساب',
    'footer.phone': 'اتصل بنا',
    'footer.x': 'إكس',
    'footer.instagram': 'إنستغرام',
    'footer.youtube': 'يوتيوب',
    'footer.col_account': 'حسابي',
    'footer.col_about': 'من نحن',
    'footer.col_categories': 'الأقسام',
    'footer.col_information': 'معلومات',
    'footer.col_talk_to_us': 'تواصل معنا',
    'footer.link_about_us': 'عن زيروتك',
    'footer.link_track_orders': 'تتبع الطلبات',
    'footer.link_wishlist': 'المفضلة',
    'footer.link_my_account': 'حسابي',
    'footer.link_order_history': 'سجل الطلبات',
    'footer.link_screens': 'الشاشات',
    'footer.link_intercom': 'إنتركم',
    'footer.link_contact_us': 'اتصل بنا',
    'footer.link_branches': 'فروعنا',
    'footer.link_return_policy': 'سياسة الاسترجاع والاستبدال',
    'footer.link_call_us': 'للاستفسار اتصل بنا',
    'footer.link_phone': '+20 104 477 7379',
    'footer.link_email': 'info@zerotechegypt.com',
    'footer.link_address': 'فيلا 18 شارع الخليفة الواثق من شارع عباس العقاد، مدينة نصر، القاهرة، مصر.',
    'footer.copy': '© 2026 جميع الحقوق محفوظة',
    'not_found.title': 'الصفحة غير موجودة',
    'not_found.subtitle': 'الصفحة التي تبحث عنها غير موجودة.',
    'not_found.back_home': 'العودة للرئيسية',
    'product.page_title': 'المنتجات',
    'product.breadcrumb': 'الرئيسية / المنتجات / تفاصيل المنتج',
    'product.breadcrumb_nav': 'مسار التنقل',
    'product.breadcrumb_home': 'الرئيسية',
    'product.current_price': 'السعر الحالي',
    'product.color_variants': 'اللون',
    'product.color_variants_selected': 'المحدد',
    'product.in_stock_warehouse': 'متوفر في المخزون',
    'product.share_label': 'مشاركة:',
    'product.link_copied': 'تم نسخ الرابط',
    'product.decrease_qty': 'تقليل الكمية',
    'product.increase_qty': 'زيادة الكمية',
    'product.hot_deal': 'عرض قوي',
    'product.best_seller': 'الأكثر مبيعًا',
    'product.general_specs': 'المواصفات العامة',
    'product.share': 'مشاركة',
    'product.zerotech': 'زيرو تك',
    'product.in_stock': 'متوفر',
    'product.out_of_stock': 'غير متوفر',
    'product.available_soon': 'سيتوفر قريبا',
    'product.free_shipping': 'شحن مجاني',
    'product.free_shipping_sub': 'شحن مجاني على هذا المنتج',
    'product.warranty': 'ضمان موثوق',
    'product.warranty_sub': 'دعم معتمد',
    'product.buy_now': 'اشتري الآن',
    'product.easy_return': 'إرجاع سهل',
    'product.easy_return_sub': 'إرجاع مجاني خلال 30 يوما.',
    'product.technical_specs': 'المواصفات التقنية',
    'product.product_description': 'وصف المنتج',
    'product.downloads_drivers': 'التنزيلات والتعريفات',
    'product.performance_details': 'تفاصيل الأداء',
    'product.physical_specs': 'المواصفات الفيزيائية',
    'product.quick_view': 'معاينة سريعة',
    'product.special_offer': 'عرض خاص',
    'product.preview_loading': 'جاري التحميل…',
    'product.load_error_title': 'تعذر تحميل المنتج',
    'product.load_error': 'المنتج غير متاح حالياً. يرجى المحاولة مرة أخرى أو العودة للرئيسية.',
    'product.preview_prev': 'الصورة السابقة',
    'product.preview_next': 'الصورة التالية',
    'product.gallery_images': 'صور المنتج',
    'product.gallery_image_n': 'صورة',
    'product.gallery_prev': 'الصورة السابقة',
    'product.gallery_next': 'الصورة التالية',
    'product.no_description': 'لا يوجد وصف متاح.',
    'product.no_extra_details': 'لا توجد تفاصيل إضافية.',
    'product.driver_downloads': 'ملفات التعريف متاحة عبر دعم العملاء لهذا الموديل.',
    'product.reviews_empty_title': 'التقييمات (0)',
    'product.reviews_empty_subtitle': 'لا توجد تقييمات بعد.',
    'product.add_review': 'أضف تقييمك',
    'product.your_name': 'اسمك',
    'product.write_review': 'اكتب تقييمك',
    'product.customers_bought': 'اشترى العملاء أيضا',
    'product.customers_bought_sub': 'أكمل تجهيزتك عالية الأداء',
    'product.view_product': 'عرض المنتج',
    'product.invalid_product': 'منتج غير صالح.',
    'product.spec_brand': 'الماركة',
    'product.spec_category': 'الفئة',
    'product.spec_sku': 'رمز المنتج',
    'product.spec_stock': 'المخزون',
    'product.spec_weight': 'الوزن',
    'product.spec_warranty': 'الضمان',
    'product.spec_shipping': 'الشحن',
    'product.spec_status': 'الحالة',
    'product.default_category': 'إلكترونيات',
    'product.not_available': 'غير متاح',
    'product.warranty_one_year': 'سنة واحدة',
    'product.fast_shipping_available': 'شحن سريع',
    'product.fast_shipping_sub': 'توصيل سريع لباب المنزل',
    'product.standard_shipping': 'شحن لجميع المحافظات',
    'product.standard_shipping_sub': 'شحن آمن وموثوق',
    'product.status_active': 'نشط',
    'product.status_inactive': 'غير نشط',
    'page.banner_aria': 'بنر زيرو تك',
    'page.promo_banner_aria': 'بنر عروض زيرو تك',
    'page.shop_by_category_subtitle': 'اعثر على احتياجك حسب القسم',
    'page.limited_time': 'لفترة محدودة',
    'page.tech_deals_title': 'أفضل عروض اليوم',
    'page.tech_deals_subtitle': 'تخفيضات سريعة على إلكترونيات مميزة',
    'page.more_categories_below': 'مرّر لأسفل لمزيد من الأقسام',
    'search.searching': 'جارٍ البحث…',
    'search.searching_for': 'جارٍ البحث عن',
    'promo.discover_now': 'اكتشف الان',
    'promo.shop_now': 'تسوق الآن',
    'promo.less_than': 'أقل من',
    'page.trust_support_title': 'دعم على مدار 24/7',
    'page.trust_support_sub': 'تواصل معنا في أي وقت',
    'page.trust_shipping_title': 'توصيل سريع',
    'page.trust_shipping_sub': 'نوصل طلبك في اسرع وقت',
    'page.trust_refund_title': 'الاسترجاع والاسترداد',
    'page.trust_refund_sub': 'ضمان استرداد الأموال',
    'page.trust_deals_title': 'عروض وخصومات',
    'page.trust_deals_sub': 'عروض على بعض المنتجات',
    'page.new_drop': 'وصل حديثا',
    'page.service_latest_tech': 'أحدث وأفضل التقنية',
    'page.service_guarantee': 'ضمان',
    'page.service_shipping_free': 'شحن مجاني فوق 1000$',
    'page.service_support': 'دعم على مدار الساعة',
    'home.modern_electronics': 'إلكترونيات حديثة لكل مساحة',
    'home.upgrade_title': 'طوّر أجهزتك مع زيرو تك',
    'home.upgrade_subtitle': 'تجميعات مختارة، باقات ذكية، وعروض حصرية مُدارة مباشرة من لوحة التحكم.',
    'home.shop_now': 'تسوق الآن',
    'home.view_offers': 'عرض العروض',
    'home.new_arrivals': 'وصل حديثا',
    'home.smart_security': 'أمان ذكي',
    'home.smart_security_subtitle': 'كاميرات ذكية وأنظمة إنتركم مدعومة بالذكاء الاصطناعي.',
    'home.featured_categories': 'أقسام مميزة',
    'home.explore': 'استكشف',
    'home.deals_discounts': 'عروض وتخفيضات',
    'home.deals_subtitle': 'عروض إطلاق وتخفيضات فلاش وباقات مختارة.',
    'home.browse_deals': 'تصفح العروض',
    'checkout.breadcrumb': 'الرئيسية / السلة / إتمام الطلب'
  },
  en: {
    'header.free_shipping': 'Free shipping across Egypt on qualifying orders',
    'header.deals': 'Best electronics deals - updated daily',
    'header.search_placeholder': 'Search products, SKU, or brands...',
    'header.search_suggestions': 'Search suggestions',
    'header.search_loading': 'Searching…',
    'header.search_no_results': 'No results',
    'header.search_view_all': 'View all results for',
    'header.sign_in': 'Sign in',
    'header.logout': 'Logout',
    'header.cart': 'Cart',
    'header.home': 'Home',
    'header.all_categories': 'All categories',
    'header.shop_by_category': 'Shop by category',
    'header.categories': 'Categories',
    'header.language': 'Language',
    'header.shop_all': 'Shop all',
    'header.view_all': 'View all',
    'offers.use_code': 'Use code',
    'offers.shop_now': 'Shop now',
    'checkout.title': 'Checkout',
    'checkout.subtitle': 'Enter shipping details and choose your payment method.',
    'checkout.shipping_and_payment': 'Shipping and payment',
    'checkout.full_name': 'Full name',
    'checkout.phone': 'Phone number',
    'checkout.phone_required': 'Phone number is required.',
    'checkout.phone_invalid': 'Enter a valid Egyptian mobile number (e.g. 01012345678).',
    'checkout.form_invalid': 'Please fix the required fields before placing your order.',
    'checkout.full_name_required': 'Full name is required.',
    'checkout.full_name_invalid': 'Full name must be at least 3 characters.',
    'checkout.address_required': 'Delivery address is required.',
    'checkout.address_invalid': 'Address must be at least 6 characters.',
    'checkout.country_required': 'Select a country.',
    'checkout.governorate_required': 'Select a governorate.',
    'checkout.city_required': 'Select a city.',
    'checkout.payment_required': 'Select a payment method.',
    'checkout.branch_required': 'Select a pickup branch.',
    'checkout.optional': 'optional',
    'checkout.email_invalid': 'Enter a valid email address.',
    'checkout.address': 'Delivery address',
    'checkout.country': 'Country',
    'checkout.select_country': 'Select country',
    'checkout.branch': 'Branch',
    'checkout.payment_method': 'Payment method',
    'checkout.payment_intro': 'Choose one option. Your order appears in the admin dashboard in all cases.',
    'checkout.payment_credit': 'Credit / debit card',
    'checkout.payment_branch': 'Receive from branch',
    'checkout.payment_cod': 'Cash on delivery',
    'checkout.hint_credit': 'Pay securely via Paymob (you will leave this site to complete payment).',
    'checkout.hint_cod': 'Pay in cash when your order arrives. No card required.',
    'checkout.hint_branch': 'Order online and pick up at your selected branch with no shipping fee.',
    'checkout.branch_pickup': 'Pickup branch',
    'checkout.notes': 'Order notes (optional)',
    'checkout.notes_placeholder': 'Delivery instructions, building name, floor, etc.',
    'checkout.discount_code': 'Discount code',
    'checkout.discount_placeholder': 'Optional promo code',
    'checkout.discount_apply': 'Apply',
    'checkout.discount_applied': 'Discount',
    'checkout.shipping_discount': 'Shipping discount',
    'checkout.complete_your_order': 'Complete your order',
    'checkout.related_products_subtitle': 'Related picks based on items in your cart',
    'checkout.discount_enter_code': 'Enter a code and tap Apply to verify.',
    'checkout.discount_not_applicable': 'This code cannot be applied to your cart.',
    'checkout.discount_preview_error': 'Could not verify the code. Try again.',
    'checkout.cod_disabled_threshold': 'Cash on delivery is unavailable because your cart total exceeds the allowed threshold.',
    'checkout.cod_unavailable': 'Unavailable',
    'product.wishlist_add': 'Add to wishlist',
    'product.wishlist_remove': 'Remove from wishlist',
    'product.wishlist_login':
      'You must sign in to complete a purchase, add items to your cart, or save items to your wishlist.',
    'product.compare_add': 'Add to compare',
    'product.compare_added': 'Added to compare',
    'product.compare_full': 'Compare list is full (max 4 products).',
    'wishlist.error': 'Could not update wishlist.',
    'wishlist.added': 'Added to wishlist.',
    'wishlist.removed': 'Removed from wishlist.',
    'checkout.loading_methods': 'Loading payment options...',
    'checkout.continue_payment': 'Continue to secure payment',
    'checkout.place_cod': 'Place order (cash on delivery)',
    'checkout.place_branch': 'Place order (receive from branch)',
    'checkout.shipping_data': 'Shipping details',
    'checkout.summary': 'Order summary',
    'checkout.confirmed': 'Order confirmed',
    'checkout.back_home': 'Back to shopping',
    'checkout.governorate': 'Governorate',
    'checkout.select_governorate': 'Select governorate',
    'checkout.city': 'City',
    'checkout.select_city': 'Select city',
    'checkout.subtotal': 'Subtotal',
    'checkout.shipping': 'Shipping (estimate)',
    'checkout.free_shipping_remaining_before': 'Spend',
    'checkout.free_shipping_remaining_after': 'to get free shipping',
    'checkout.shipping_base': 'Base shipping',
    'checkout.shipping_extra': 'Extra weight',
    'checkout.shipping_included_kg': 'Included weight',
    'checkout.shipping_dynamic_note': 'Shipping is dynamic: if product weight exceeds included KG set by admin, extra fee per KG is applied automatically.',
    'checkout.total': 'Total',
    'checkout.order_number': 'Order number',
    'checkout.email': 'Email',
    'checkout.leave_title': 'Leaving checkout?',
    'checkout.leave_subtitle': 'Tell us why you’re leaving — it helps us improve.',
    'checkout.leave_reason_price': 'Price is too high',
    'checkout.leave_reason_shipping': 'Shipping / delivery',
    'checkout.leave_reason_payment': 'Payment concerns',
    'checkout.leave_reason_browsing': 'Just browsing',
    'checkout.leave_reason_other': 'Other',
    'checkout.leave_note_label': 'Note (optional)',
    'checkout.leave_note_placeholder': 'Add details if you like…',
    'checkout.leave_stay': 'Stay and finish',
    'checkout.leave_confirm': 'Leave',
    'checkout.thank_you': 'Thank you! Your order',
    'checkout.created_success': 'was created successfully.',
    'checkout.redirecting_paymob': 'Redirecting to Paymob...',
    'checkout.placing_order': 'Placing your order...',
    'checkout.error_load_branches': 'Could not load branches.',
    'checkout.error_place_order': 'Unable to place your order right now. Please try again.',
    'checkout.paymob_return_success': 'Payment completed. Your order is confirmed.',
    'checkout.paymob_return_failed': 'Payment was not completed. You can try again or choose another payment method.',
    'checkout.paymob_return_failed_title': 'Payment failed',
    'checkout.paymob_return_unknown': 'The payment flow ended. If you were charged but your order is not confirmed, contact support.',
    'checkout.paymob_return_failed_stale_state':
      'Payment was declined, but your order still shows as pending—the Paymob server callback may not have reached the API (check Paymob:CallbackUrl and Paymob:HmacSecret). The order will not be treated as confirmed for fulfillment.',
    'checkout.loading_locations': 'Loading locations...',
    'common.scroll_previous': 'Previous',
    'common.scroll_next': 'Next',
    'carousel.scroll_categories': 'Scroll categories',
    'carousel.scroll_products': 'Scroll products',
    'common.view': 'View',
    'common.search': 'Search',
    'common.filters': 'Filters',
    'common.loading_page': 'Loading page…',
    'common.loading_sections': 'Loading sections…',
    'common.categories': 'Categories',
    'common.featured_products': 'Featured products',
    'common.price': 'Price',
    'common.sort': 'Sort',
    'common.recommended': 'Recommended',
    'common.price_low_high': 'Price: Low to High',
    'common.price_high_low': 'Price: High to Low',
    'common.add_to_cart': 'Add to cart',
    'common.added': 'Added',
    'common.cancel': 'Cancel',
    'common.close': 'Close',
    'contact.call_chooser_title': 'Choose a number to call',
    'contact.call_mobile': 'Mobile',
    'contact.call_hotline': 'Hotline',
    'contact.dock_label': 'Contact us',
    'common.search_results': 'Search Results',
    'common.no_products': 'No products available',
    'common.request_failed': 'Request failed. Please try again.',
    'common.sign_in_required_title': 'Sign in required',
    'common.sign_in_required_detail':
      'You must sign in to complete a purchase, add items to your cart, or save items to your wishlist.',
    'cart.added': 'Product added to cart.',
    'cart.login_required':
      'You must sign in to complete a purchase, add items to your cart, or save items to your wishlist.',
    'cart.add_error': 'Unable to add item to cart.',
    'header.english': 'English',
    'header.arabic': 'Arabic',
    'header.home_aria': 'ZeroTech stores home',
    'header.account': 'Account',
    'header.wishlist': 'Wishlist',
    'header.my_orders': 'My orders',
    'header.compare': 'Compare',
    'header.categories_label': 'Categories',
    'header.quick_links': 'Quick links',
    'header.track_order': 'Track my order',
    'header.contact_us': 'Contact us',
    'wishlist.title': 'Wishlist',
    'wishlist.subtitle': 'Products you saved to review later.',
    'wishlist.empty_title': 'Your wishlist is empty',
    'wishlist.empty_subtitle': 'Add products from product pages to see them here.',
    'wishlist.empty_cta': 'Continue shopping',
    'wishlist.move_all': 'Move all to bag',
    'wishlist.move_all_done': 'Items added to your cart',
    'wishlist.remove': 'Remove',
    'wishlist.move_to_cart': 'Add to cart',
    'wishlist.loading': 'Loading wishlist...',
    'wishlist.load_error': 'Could not load wishlist. Please try again.',
    'compare.title': 'Compare products',
    'compare.subtitle': 'Compare up to four products side by side.',
    'compare.empty': 'Nothing to compare yet',
    'compare.add_products': 'Add products from detail pages or listings.',
    'compare.browse': 'Browse products',
    'compare.clear': 'Clear all',
    'compare.full_hint': 'You can compare up to 4 products.',
    'compare.column_product': 'Product',
    'compare.column_price': 'Price',
    'compare.column_brand': 'Brand',
    'compare.column_stock': 'Availability',
    'compare.column_category': 'Category',
    'compare.remove': 'Remove from compare',
    'compare.loading': 'Loading...',
    'compare.in_stock': 'In stock',
    'compare.out_of_stock': 'Out of stock',
    'support.title': 'Support',
    'support.subtitle': 'Get in touch for help or questions.',
    'support.form_heading': 'Get in touch',
    'support.form_intro': 'Send a message and we will get back to you as soon as we can.',
    'support.form_name': 'Name',
    'support.form_name_ph': 'Your name (optional)',
    'support.form_email': 'Email',
    'support.form_email_ph': 'you@example.com',
    'support.form_message': 'Message',
    'support.form_message_ph': 'How can we help?',
    'support.submit': 'Send',
    'support.form_success': 'Thanks — your message was received.',
    'support.contact_title': 'Contact',
    'support.contact_phone': 'Phone',
    'support.contact_email': 'Email',
    'support.contact_hours': 'Sun–Thu 10am–6pm',
    'support.map_placeholder': 'Map — embed your map here later',
    'support.map_aria': 'Approximate location map',
    'return_policy.title': 'Return and Exchange Policy',
    'return_policy.subtitle': 'Our updated return and exchange policy for company products.',
    'return_policy.main_heading': 'Updated Return and Exchange Policy for Our Company Products',
    'return_policy.section1_title': 'First: Return or exchange due to a manufacturing defect',
    'return_policy.section1_body':
      'Our customer may exchange or return a product within thirty days of purchase only when a manufacturing defect is confirmed by a technical report from our authorized service or maintenance centers. This condition includes personal care products in compliance with health and legal requirements. After this period, the product cannot be exchanged or returned for any reason; the customer must contact customer service on +20 104 477 7379 to register a maintenance claim in accordance with Article 21 of the Consumer Protection Law.',
    'return_policy.section2_title': 'Second: General conditions for return or exchange',
    'return_policy.section2_body':
      'When returning or exchanging a product, the original packaging and all packing materials must be intact, the product must include all original contents and must not have been opened or used, and it must be accompanied by all original documents including the invoice. If a gift was included with the purchase, it must be returned with the product; otherwise the exchange or return will not be accepted. If a product purchased at a discounted price or as part of a promotion is returned or exchanged, only the amount paid by the customer will be refunded.',
    'return_policy.section3_title': 'Third: Return or exchange without a manufacturing defect',
    'return_policy.section3_intro':
      'If the customer wishes to exchange or return a product without a manufacturing defect within fourteen days of receiving the product—except personal care products, which are subject to special health conditions under Article 17 of the Consumer Protection Law—the following applies:',
    'return_policy.section3_item1_title': 'If the product packaging was not opened or used and the product remains in its original condition',
    'return_policy.section3_item1_body':
      'The consumer may request an exchange or refund within the stated period provided the product is in the same condition as at the time of contract, i.e. not opened or used. In this case, the product may be exchanged with any price difference between models settled, or returned and refunded after deducting shipping fees of 300 EGP for air conditioners only, in accordance with Article 40 paragraphs 1 and 2 of the Consumer Protection Law. In addition, for electronic payment via VISA / Master, Vodafone Cash, or Etisalat Cash, an administrative fee of 1.5% of the product value applies; for Fawry payments, 2.25%; and for MPOS machines, 1.45% + 1 EGP.',
    'return_policy.section3_item2_title': 'If the product packaging was opened',
    'return_policy.section3_item2_body':
      'Although Article 17 paragraph 2 of the Consumer Protection Law may not grant the consumer the right to exchange or return if the product packaging was opened or used, as an exception and for flexibility, the product may be exchanged with any price difference between models settled, or returned and refunded after deducting 5% of the total product value for repackaging, plus shipping fees (300 EGP for air conditioners) and all administrative fees mentioned above for electronic payment.',
    'return_policy.contact_lead': 'For inquiries or to register a maintenance claim, contact customer service on',
    'branches.title': 'Our Branches',
    'branches.tagline': 'Closer than you think ✨',
    'branches.subtitle': 'Wherever you are, you will find a branch near you 📍',
    'branches.map': '📍 Map',
    'branches.call': '📞 Call',
    'branches.whatsapp': '💬 WhatsApp',
    'branches.hotline_lead': 'Visit your nearest branch or call us on',
    'branches.loading': 'Loading branches...',
    'branches.empty': 'No branches are available right now.',
    'branches.load_error': 'Could not load branches. Please try again later.',
    'account.auth_hero_title': 'Welcome to ZeroTech',
    'account.auth_hero_subtitle': 'Sign in or create an account to manage orders and your cart.',
    'account.hero_login': 'Login',
    'account.hero_register': 'Register',
    'account.register_account_title': 'Register account',
    'account.confirm_password_placeholder': 'Confirm your password',
    'account.accept_terms_prefix': 'I agree to the',
    'account.terms_link': 'Terms',
    'account.accept_terms_and': 'and',
    'account.privacy_link': 'Privacy Policy',
    'account.no_account': "Don't have an account?",
    'account.have_account': 'Already have an account?',
    'search.subtitle': 'Find products, bundles, and offers.',
    'search.enter_query': 'Enter a search term to see products.',
    'header.view_category': 'View category',
    'header.expand_category': 'Expand',
    'header.collapse_category': 'Collapse',
    'catalog.filter_products': 'Filter products',
    'catalog.product_listing': 'Product listing',
    'catalog.sort_products': 'Sort products',
    'catalog.min': 'Min',
    'catalog.max': 'Max',
    'catalog.apply_price': 'Apply price',
    'catalog.brand': 'Brand',
    'catalog.no_brand_data': 'No brand data available in this category.',
    'catalog.availability': 'Availability',
    'catalog.in_stock_only': 'In stock only',
    'catalog.clear_filters': 'Clear all filters',
    'catalog.loading_products': 'Loading products...',
    'catalog.features': 'Features',
    'catalog.sale': 'Sale',
    'catalog.new': 'New',
    'catalog.all_products': 'All Products',
    'catalog.unknown_category': 'This category',
    'catalog.product_count_badge': 'Product count',
    'catalog.no_products_filtered': 'No products matched your filters.',
    'catalog.load_error': 'Unable to load products.',
    'account.secure_account': 'Secure account',
    'account.sign_in_title': 'Sign in to your account',
    'account.create_title': 'Create your account',
    'account.sign_in_subtitle': 'Access your cart, checkout, and orders.',
    'account.create_subtitle': 'Register to save your cart and complete checkout.',
    'account.login': 'Login',
    'account.register': 'Register',
    'account.full_name': 'Full name',
    'account.full_name_placeholder': 'Your full name',
    'account.email': 'Email',
    'account.email_placeholder': 'you@example.com',
    'account.phone_number': 'Phone number',
    'account.phone_placeholder': '01012345678',
    'account.phone_required': 'Phone number is required.',
    'account.phone_invalid': 'Enter a valid Egyptian mobile number with exactly 11 digits (e.g. 01012345678).',
    'account.email_required': 'Email is required.',
    'account.email_invalid': 'Enter a valid email address.',
    'account.full_name_required': 'Full name is required.',
    'account.full_name_invalid': 'Full name must be at least 3 characters.',
    'account.password': 'Password',
    'account.password_placeholder': 'Minimum 6 characters',
    'account.password_required': 'Password is required.',
    'account.password_min': 'Password must be at least 6 characters.',
    'account.terms_required': 'You must accept the Terms and Privacy Policy.',
    'account.forgot_password': 'Forgot password?',
    'account.forgot_title': 'Reset your password',
    'account.forgot_subtitle': 'Enter your registered email and we will send a reset link.',
    'account.forgot_submit': 'Send reset link',
    'account.forgot_success': 'If an account exists for that email, a password reset link has been sent.',
    'account.forgot_send_failed': 'Could not send the password reset email. Please try again later.',
    'account.reset_password': 'Reset password',
    'account.reset_title': 'Choose a new password',
    'account.reset_subtitle': 'Enter your new password twice.',
    'account.reset_submit': 'Save password',
    'account.reset_success': 'Password updated. You can sign in now.',
    'account.reset_failed': 'Could not reset the password. The link is invalid or expired.',
    'account.reset_token_missing': 'This reset link is incomplete.',
    'account.back_to_login': 'Back to sign in',
    'account.show_password': 'Show password',
    'account.hide_password': 'Hide password',
    'account.please_wait': 'Please wait...',
    'account.sign_in': 'Sign in',
    'account.create_account': 'Create account',
    'account.overview': 'Overview',
    'account.orders': 'Orders',
    'account.addresses': 'Addresses',
    'account.security': 'Security',
    'account.change_password': 'Change password',
    'account.change_password_hint': 'Enter your current password and choose a new one.',
    'account.current_password': 'Current password',
    'account.new_password': 'New password',
    'account.confirm_password': 'Confirm new password',
    'account.update_password': 'Update password',
    'account.password_mismatch': 'New password and confirmation do not match.',
    'account.password_same_as_current': 'New password must be different from your current password.',
    'account.current_password_incorrect': 'Current password is not correct.',
    'account.password_changed': 'Your password was updated successfully.',
    'account.password_change_failed': 'Could not update password. Check your current password.',
    'account.sign_out': 'Sign Out',
    'account.core_information': 'Core Information',
    'account.email_address': 'Email Address',
    'account.save_profile': 'Save details',
    'account.profile_updated': 'Your profile was updated successfully.',
    'account.profile_update_failed': 'Could not update your profile. Please try again.',
    'account.profile_load_failed': 'Could not load your account details.',
    'account.email_already_exists': 'This email is already registered.',
    'account.loading_orders': 'Loading your orders...',
    'account.no_orders': 'No orders yet.',
    'account.request_failed': 'Unable to complete the request. Please try again.',
    'account.session_expired_title': 'Session expired',
    'account.session_expired_message': 'Your session has ended. Please sign in again to continue.',
    'toast.notice': 'Notice',
    'toast.cart_updated': 'Cart updated',
    'account.total': 'Total',
    'account.shipping': 'Shipping',
    'account.status': 'Status',
    'account.status_delivered': 'Delivered',
    'account.status_cancelled': 'Cancelled',
    'account.status_returned': 'Returned',
    'account.status_in_progress': 'In Progress',
    'account.col_order_ref': 'Order Reference',
    'account.col_product': 'Product',
    'account.col_date': 'Acquisition Date',
    'account.col_status': 'Status Metric',
    'account.col_total': 'Total Value',
    'account.col_details': 'Details',
    'account.view_details': 'View',
    'account.view_order': 'View order',
    'account.back_to_orders': 'Back to orders',
    'account.loading_order_detail': 'Loading order details...',
    'account.order_detail_failed': 'Could not load order details.',
    'account.payment_method': 'Payment method',
    'account.payment_status': 'Payment status',
    'account.shipping_details': 'Shipping',
    'account.order_items': 'Items',
    'account.qty': 'Qty',
    'account.subtotal': 'Subtotal',
    'account.discount': 'Discount',
    'account.notes': 'Notes',
    'account.status_pending': 'Pending',
    'account.status_confirmed': 'Confirmed',
    'account.status_processing': 'Processing',
    'account.status_shipped': 'Shipped',
    'account.status_declined': 'Declined',
    'account.payment_pending': 'Pending',
    'account.payment_processing': 'Processing',
    'account.payment_completed': 'Completed',
    'account.payment_failed': 'Failed',
    'account.payment_refunded': 'Refunded',
    'account.payment_cancelled': 'Cancelled',
    'account.payment_declined': 'Declined',
    'account.advanced_filters': 'Advanced Filters',
    'account.filters_hint': 'Advanced filters will connect to order search in a future update.',
    'account.section_soon': 'This section is coming soon.',
    'cart.breadcrumb': 'Home / Shopping Cart',
    'cart.breadcrumb_home': 'Home',
    'cart.breadcrumb_current': 'Shopping Cart',
    'cart.hero_title': 'Shopping Cart',
    'cart.title': 'Shopping Cart',
    'cart.recommended_title': 'Recommended for you',
    'cart.recommended_subtitle': 'Similar products from categories in your cart',
    'cart.empty_button': 'Empty Shopping Cart',
    'cart.remove': 'Remove',
    'cart.remove_item': 'Remove item from cart',
    'checkout.cart_empty': 'Your cart is empty. Add products to continue.',
    'cart.coupon_placeholder': 'Enter Coupon Code',
    'cart.apply_coupon': 'Apply',
    'cart.available_offers': 'Available offers',
    'cart.tap_to_apply': 'Tap an offer to apply instantly, or type another code manually.',
    'cart.offer_applied': 'Applied',
    'cart.order_summary': 'Order Summary',
    'cart.subtotal': 'Subtotal',
    'cart.total': 'Total',
    'cart.proceed_checkout': 'Proceed to checkout',
    'cart.empty_title': 'Your Cart is empty',
    'cart.empty_subtitle': 'Add products to your cart to continue checkout.',
    'cart.continue_shopping': 'Continue Shopping',
    'cart.sign_in_required': 'Sign in required',
    'cart.sign_in_prompt': 'Please sign in to view and manage your cart.',
    'cart.go_to_account': 'Go to account',
    'cart.coupon_discount': 'Coupon discount',
    'cart.use_code': 'Use code',
    'cart.shipping_note': '(Shipping fees not Included)',
    'cart.coupon_enter_code': 'Please enter a coupon code.',
    'cart.coupon_not_available': 'Coupon codes are not available yet.',
    'cart.item_removed': 'Item removed from cart.',
    'cart.item_remove_failed': 'Unable to remove item.',
    'cart.cleared': 'Cart emptied.',
    'cart.clear_failed': 'Unable to empty cart.',
    'cart.quantity_label': 'Quantity',
    'footer.newsletter_title': 'Subscribe to our newsletter',
    'footer.email_placeholder': 'Enter your email',
    'footer.submit': 'Submit',
    'footer.tagline': 'We offer end-to-end security solutions and have achieved amazing success across a wide range of industry verticals.',
    'footer.language': 'Language',
    'footer.lang_ar': 'Arabic',
    'footer.lang_en': 'English',
    'footer.social_links': 'Social links',
    'footer.facebook': 'Facebook',
    'footer.whatsapp': 'WhatsApp',
    'footer.phone': 'Call us',
    'footer.x': 'X',
    'footer.instagram': 'Instagram',
    'footer.youtube': 'YouTube',
    'footer.col_account': 'My Account',
    'footer.col_about': 'About Us',
    'footer.col_categories': 'Categories',
    'footer.col_information': 'Information',
    'footer.col_talk_to_us': 'Talk To Us',
    'footer.link_about_us': 'About ZeroTech',
    'footer.link_track_orders': 'Track Orders',
    'footer.link_wishlist': 'Wishlist',
    'footer.link_my_account': 'My Account',
    'footer.link_order_history': 'Order History',
    'footer.link_screens': 'Screens',
    'footer.link_intercom': 'Intercom',
    'footer.link_contact_us': 'Contact Us',
    'footer.link_branches': 'Our Branches',
    'footer.link_return_policy': 'Return and Exchange Policy',
    'footer.link_call_us': 'Got Questions? Call us',
    'footer.link_phone': '+20 104 477 7379',
    'footer.link_email': 'info@zerotechegypt.com',
    'footer.link_address': 'Villa 18 Al-Khalifa Al-Watheq St. from Abbas El-Akkad St, Nasr City, Cairo, Egypt.',
    'footer.copy': '© 2026 All Rights Reserved',
    'not_found.title': 'Page not found',
    'not_found.subtitle': 'The page you are looking for does not exist.',
    'not_found.back_home': 'Back to home',
    'product.page_title': 'PRODUCTS',
    'product.breadcrumb': 'Home / Products / Product Details',
    'product.breadcrumb_nav': 'Breadcrumb',
    'product.breadcrumb_home': 'Home',
    'product.current_price': 'Current price',
    'product.color_variants': 'Color',
    'product.color_variants_selected': 'Selected',
    'product.in_stock_warehouse': 'In stock',
    'product.share_label': 'Share:',
    'product.link_copied': 'Link copied',
    'product.decrease_qty': 'Decrease quantity',
    'product.increase_qty': 'Increase quantity',
    'product.hot_deal': 'HOT DEAL',
    'product.best_seller': 'Best Seller',
    'product.general_specs': 'General Specifications',
    'product.share': 'Share',
    'product.zerotech': 'ZEROTECH',
    'product.in_stock': 'In Stock',
    'product.out_of_stock': 'Out of Stock',
    'product.available_soon': 'Will be available soon',
    'product.free_shipping': 'FREE SHIPPING',
    'product.free_shipping_sub': 'This product ships free',
    'product.warranty': 'Trusted Warranty',
    'product.warranty_sub': 'Genuine Support',
    'product.buy_now': 'Buy Now',
    'product.easy_return': 'Easy Return',
    'product.easy_return_sub': 'Free 30 Days Delivery Returns.',
    'product.technical_specs': 'Technical Specifications',
    'product.product_description': 'Product Description',
    'product.downloads_drivers': 'Downloads & Drivers',
    'product.performance_details': 'Performance Details',
    'product.physical_specs': 'Physical Specs',
    'product.quick_view': 'Quick View',
    'product.special_offer': 'Special Offer',
    'product.preview_loading': 'Loading…',
    'product.load_error_title': 'Product unavailable',
    'product.load_error': 'We could not load this product. Please try again or return to the homepage.',
    'product.preview_prev': 'Previous image',
    'product.preview_next': 'Next image',
    'product.gallery_images': 'Product images',
    'product.gallery_image_n': 'Image',
    'product.gallery_prev': 'Previous image',
    'product.gallery_next': 'Next image',
    'product.no_description': 'No description available.',
    'product.no_extra_details': 'No extra details.',
    'product.driver_downloads': 'Driver downloads are available through customer support for this product model.',
    'product.reviews_empty_title': 'Reviews (0)',
    'product.reviews_empty_subtitle': 'Looks like there are no reviews yet.',
    'product.add_review': 'Add your review',
    'product.your_name': 'Your name',
    'product.write_review': 'Write your review',
    'product.customers_bought': 'CUSTOMERS ALSO BOUGHT',
    'product.customers_bought_sub': 'Complete your high-performance setup',
    'product.view_product': 'View product',
    'product.invalid_product': 'Invalid product.',
    'product.spec_brand': 'Brand',
    'product.spec_category': 'Category',
    'product.spec_sku': 'SKU',
    'product.spec_stock': 'Stock',
    'product.spec_weight': 'Weight',
    'product.spec_warranty': 'Warranty',
    'product.spec_shipping': 'Shipping',
    'product.spec_status': 'Status',
    'product.default_category': 'Electronics',
    'product.not_available': 'N/A',
    'product.warranty_one_year': '1 year',
    'product.fast_shipping_available': 'Fast shipping',
    'product.fast_shipping_sub': 'Express doorstep delivery',
    'product.standard_shipping': 'Delivery to all governorates',
    'product.standard_shipping_sub': 'Safe and reliable shipping',
    'product.status_active': 'Active',
    'product.status_inactive': 'Inactive',
    'page.banner_aria': 'ZeroTech store banner',
    'page.promo_banner_aria': 'ZeroTech promo banner',
    'page.shop_by_category_subtitle': 'Find what you need by department',
    'page.limited_time': 'Limited Time',
    'page.tech_deals_title': "Today's Tech Deals",
    'page.tech_deals_subtitle': 'Flash sales on premium electronics',
    'page.more_categories_below': 'Scroll for more categories',
    'search.searching': 'Searching…',
    'search.searching_for': 'Searching for',
    'promo.discover_now': 'Discover now',
    'promo.shop_now': 'Shop now',
    'promo.less_than': 'Less than',
    'page.trust_support_title': '24/7 Support',
    'page.trust_support_sub': 'Contact us anytime',
    'page.trust_shipping_title': 'Fast delivery',
    'page.trust_shipping_sub': 'We deliver as quickly as possible',
    'page.trust_refund_title': 'Returns & refunds',
    'page.trust_refund_sub': 'Money-back guarantee',
    'page.trust_deals_title': 'Offers & discounts',
    'page.trust_deals_sub': 'Deals on selected products',
    'page.new_drop': 'New drop',
    'page.service_latest_tech': 'Latest and Greatest Tech',
    'page.service_guarantee': 'Guarantee',
    'page.service_shipping_free': 'Free Shipping over 1000$',
    'page.service_support': '24/7 Support',
    'home.modern_electronics': 'Modern electronics for every space',
    'home.upgrade_title': 'Upgrade your tech stack with ZeroTech',
    'home.upgrade_subtitle': 'Curated collections, smart bundles, and exclusive deals managed directly from your dashboard.',
    'home.shop_now': 'Shop now',
    'home.view_offers': 'View offers',
    'home.new_arrivals': 'New arrivals',
    'home.smart_security': 'Smart Security',
    'home.smart_security_subtitle': 'AI-powered cameras and intercoms.',
    'home.featured_categories': 'Featured categories',
    'home.explore': 'Explore',
    'home.deals_discounts': 'Deals & discounts',
    'home.deals_subtitle': 'Launch promotions, flash sales, and curated bundles.',
    'home.browse_deals': 'Browse deals',
    'checkout.breadcrumb': 'Home / Cart / Checkout'
  }
};

const CATEGORY_AR_EN: Record<string, string> = {
  'Laptops': 'لابتوبات',
  'Tablets': 'أجهزة لوحية',
  'Smart Watches': 'ساعات ذكية',
  'Gaming Laptops': 'لابتوبات ألعاب',
  'Business Laptops': 'لابتوبات أعمال',
  'Accessories': 'إكسسوارات',
  'Smartphones': 'هواتف ذكية',
  'Phone Cases': 'أغطية هواتف',
  'Chargers': 'شواحن',
  'Smart TVs': 'تلفزيونات ذكية',
  'Sound Systems': 'أنظمة صوت',
  'TV Accessories': 'إكسسوارات تلفزيون',
  'Electronics': 'إلكترونيات',
  'Computers': 'كمبيوتر',
  'Mobile Phones': 'هواتف محمولة',
  'TV & Audio': 'تلفزيون وصوت',
  'Featured': 'مميزة',
  'Best Sellers': 'الأكثر مبيعا',
  'New Arrivals': 'وصل حديثا'
};

@Injectable({
  providedIn: 'root'
})
export class I18nService {
  private readonly languageSubject = new BehaviorSubject<AppLanguage>(this.readInitialLanguage());
  readonly language$ = this.languageSubject.asObservable();

  constructor() {
    this.applyDocumentLanguage();
  }

  get language(): AppLanguage {
    return this.languageSubject.value;
  }

  get isArabic(): boolean {
    return this.language === 'ar';
  }

  setLanguage(lang: AppLanguage): void {
    this.languageSubject.next(lang);
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(STORAGE_KEY, lang);
    }
    this.applyDocumentLanguage(lang);
  }

  /** Sync <html lang/dir> so the whole storefront flows RTL in Arabic. */
  applyDocumentLanguage(lang: AppLanguage = this.language): void {
    if (typeof document === 'undefined') {
      return;
    }
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
  }

  toggleLanguage(): void {
    this.setLanguage(this.language === 'ar' ? 'en' : 'ar');
  }

  t(key: string, fallback = ''): string {
    return DICTS[this.language][key] ?? (fallback || key);
  }

  /**
   * Section copy stores Arabic in the base field and English in the `*En` twin,
   * falling back to the other language rather than rendering an empty heading.
   */
  localizeSectionTitle(title: string, titleEn?: string | null): string {
    const ar = (title || '').trim();
    const en = (titleEn || '').trim();
    if (this.language === 'ar') {
      return ar || en;
    }
    return en || ar;
  }

  localizeSectionDescription(description?: string | null, descriptionEn?: string | null): string {
    return this.localizeSectionTitle(description ?? '', descriptionEn);
  }

  /** Admin-editable product card badge (e.g. "Best Seller"); Arabic is the base field, `tagEn` its twin. */
  localizeProductTag(tag?: string | null, tagEn?: string | null): string {
    return this.localizeSectionTitle(tag ?? '', tagEn);
  }

  localizeCategoryName(name: string, nameEn?: string | null, nameAr?: string | null): string {
    const fallback = (name || '').trim();
    const enValue = (nameEn || '').trim();
    const arValue = (nameAr || '').trim();

    if (this.language === 'ar') {
      if (arValue) return arValue;
      if (!fallback) return fallback;
      return CATEGORY_AR_EN[fallback] ?? fallback;
    }

    if (enValue) return enValue;
    if (!fallback) return fallback;
    const reverse = Object.entries(CATEGORY_AR_EN).find(([, ar]) => ar === fallback);
    return reverse?.[0] ?? fallback;
  }

  /** Product title for cards / PDP based on site language. */
  localizeProductName(name: string, nameEn?: string | null, nameAr?: string | null): string {
    const fallback = (name || '').trim();
    const enValue = (nameEn || '').trim();
    const arValue = (nameAr || '').trim();

    if (this.language === 'ar') {
      return arValue || fallback;
    }

    return enValue || fallback;
  }

  /** Governorate / city label for checkout based on site language. */
  localizeLocationName(name: string, nameEn?: string | null, nameAr?: string | null): string {
    const fallback = (name || '').trim();
    const enValue = (nameEn || '').trim();
    const arValue = (nameAr || '').trim();

    if (this.language === 'ar') {
      return arValue || fallback;
    }

    return enValue || fallback;
  }

  private readInitialLanguage(): AppLanguage {
    if (typeof localStorage === 'undefined') {
      return 'ar';
    }
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'ar' || saved === 'en') {
      return saved;
    }
    return 'ar';
  }
}

